import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import InquiryForm from "./InquiryForm";

/**
 * Modal wrapper for the Fitment Assistance workflow. Reuses InquiryForm in
 * "fitment" mode with auto-populated product/vehicle context.
 */
export default function FitmentAssistModal({ prefill = {}, onClose }) {
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/70 backdrop-blur-sm p-4 overflow-y-auto" data-testid="fitment-modal" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="storefront bg-[#0b0b0b] text-zinc-100 border border-white/10 rounded-lg w-full max-w-2xl my-8 shadow-2xl">
        <div className="flex items-start justify-between px-6 py-5 border-b border-white/10">
          <div>
            <h2 className="font-display text-2xl tracking-tight">Request Fitment Assistance</h2>
            <p className="text-sm text-zinc-400 mt-1">Not sure it fits? Send us your vehicle details and we'll verify before you order.</p>
          </div>
          <button onClick={onClose} data-testid="fitment-modal-close" className="p-2 hover:bg-white/10 rounded-md shrink-0"><X size={18} /></button>
        </div>
        <div className="px-6 py-5">
          <InquiryForm inquiryType="fitment" prefill={prefill} />
        </div>
      </div>
    </div>,
    document.body
  );
}
